module.exports = __webpack_public_path__ + "components/country-flag/static/yt-321f182f565b489cb4461f2fca0fdd88.svg";